<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-line
            type="search"
            label="라인"
            name="lineId"
            v-model="searchParam.lineId">
          </c-line>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 점검년월(예정, 완료) -->
          <c-datepicker
            label="점검년월"
            name="month"
            type="month"
            v-model="searchParam.month">
          </c-datepicker>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 진행상태 -->
          <c-select
            type="search"
            stepperGrpCd="MIM_CHECK_STATUS_CD"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            name="checkStatusCd"
            label="진행상태"
            v-model="searchParam.checkStatusCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-dept
            :editable="editable"
            type="search"
            label="점검부서"
            name="checkDeptCd"
            v-model="searchParam.checkDeptCd">
          </c-dept>
        </div>
        <!-- 점검일 -->
        <!-- <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2">
          <c-datepicker
            :range="true"
            name="period"
            label="점검완료일"
            v-model="period"
          ></c-datepicker>
        </div> -->
      </template>
    </c-search-box>
    <q-table
      grid
      title=""
      :data="grid.data"
      :columns="grid.columns"
      hide-header
      hide-bottom
      :rows-per-page-options="[0]"
      virtual-scroll
    >
      <template v-slot:item="props">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3">
          <q-card class="mobileTableCardLayer" @click="linkClick(null,props.row)">
            <q-card-section horizontal class="bg-grey-2">
              <q-card-section class="q-pt-xs">
                <div class="text-grid-title q-mt-sm q-mb-xs">{{ props.row.deteriorName }}</div>
              </q-card-section>
            </q-card-section>
            <q-card-section class="grid-card-etc">
              <div class="text-grid-etc-title">
                점검부서 :
              </div>
              <div class="text-grid-etc">
                {{ props.row.checkDeptName }}
              </div>
              <div :class="['text-grid-etc', getColorStatus(props.row.checkStatusCd)]">
                {{ props.row.checkStatusName }}
              </div>
              <div :class="['text-grid-etc', getColorStatus2(props.row.approvalStatusCd)]">
                {{ props.row.approvalStatusName }}
              </div>
            </q-card-section>
          </q-card>
        </div>
      </template>
    </q-table>
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3" v-if="grid.data.length === 0">
      <q-card class="mobileTableCardLayer">
        <q-card-section horizontal class="bg-grey-2 text-center">
          <q-card-section class="q-pt-xs">
            <div class="text-grid-title q-mt-sm q-mb-xs">데이터가 존재하지 않습니다.</div>
          </q-card-section>
        </q-card-section>
      </q-card>
    </div>
    <!-- <c-table
      ref="table"
      title="열화관리점검 목록"
      :columns="grid.columns"
      :data="grid.data"
      :merge="grid.merge"
      :filtering="false"
      :columnSetting="false"
      :isFullScreen="false"
      :isTop="false"
      rowKey="minEquipmentCheckId"
      @linkClick="linkClick"
    >
      <template slot="table-button">
        <div>
          <q-btn-group>
            <c-btn label="등록" :editable="editable" icon="add" @btnClicked="onItemClick" />
          </q-btn-group>
        </div>
      </template>
    </c-table> -->
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import mobileConfig from '@/js/mobileConfig';
export default {
  name: "equipment-daily_inspection",
  props: {
    popupParam: {
      type: Object,
      default: function() {
        return {
          equipmentTypeCd: '',
          grade: '',
          inspectionCycleCd: '',
        }
      },
    },
  },
  data() {
    return {
      grid: {
        columns: [
          // {
          //   name: "plantName",
          //   field: "plantName",
          //   style: 'width:100px',
          //   label: "사업장",
          //   align: "center",
          //   sortable: false,
          // },
          {
            name: "lineCd",
            field: "lineCd",
            style: 'width:80px',
            label: "라인",
            align: "center",
            sortable: false,
          },
          {
            name: "deteriorName",
            field: "deteriorName",
            style: 'width:200px',
            label: "점검명",
            align: "left",
            type: "link",
            sortable: false,
          },
          {
            name: "checkStatusName",
            field: "checkStatusName",
            label: "진행단계",
            style: 'width:100px',
            align: "center",
            sortable: false,
          },
          // {
          //   name: 'approvalStatusName',
          //   field: 'approvalStatusName',
          //   label: '결재진행단계',
          //   align: 'center',
          //   sortable: true,
          //   style: 'width:100px',
          // },
          // {
          //   name: "checkDate",
          //   field: "checkDate",
          //   style: 'width:100px',
          //   label: "점검월",
          //   align: "center",
          //   sortable: false,
          // },
          // {
          //   name: "checkUserName",
          //   field: "checkUserName",
          //   style: 'width:100px',
          //   label: "점검자",
          //   align: "center",
          //   sortable: false,
          // },
        ],
        data: [],
      },
      searchParam: {
        plantCd: null,
        month: '',
        lineId: '',
        checkDeptCd: '',
      },
      period: [ '', ''],
      editable: true,
      checkNoPlanItems: [
        { code: 'Y', codeName: '무계획' },
        { code: 'N', codeName: '계획' }
      ], // 점검진행상태
      colorItems: [
        { stepperMstCd: 'MCSC000005', stepperMstNm: '계획수립', colorClass: 'blue' },
        { stepperMstCd: 'MCSC000010', stepperMstNm: '점검중', colorClass: 'orange' },
        { stepperMstCd: 'MCSC000015', stepperMstNm: '점검완료', colorClass: 'green' },
        { stepperMstCd: 'MCSC000020', stepperMstNm: '지연', colorClass: 'red' },
      ],
      listUrl: '',
      deleteUrl: '',
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      isResult: false,
      selected: [],
    };
  },
  watch: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  beforeRouteLeave(to, from, next) { // history.back 일경우 팝업이라면 팝업을 닫자
    if (this.popupOptions.visible) {
      this.closePopup();
      next(false);
    } else {
      next();
    }
  },
  methods: {
    init() {
      // role setting
      // url setting
      this.listUrl = selectConfig.sop.min.equipment.plan.deterior.list.url;
      this.findResultUrl = mobileConfig.sop.min.equipment.result.deterior.resultFind.url;
      this.searchParam.month = this.$comm.getThisMonth();

      // this.searchParam.checkDeptCd = this.$store.getters.user.deptCd
      // this.searchParam.checkUserId = this.$store.getters.user.userId
      if (this.$route.query.equipmentCd) {
        this.getDailyDetail();
      }
      this.getList();
    },
    getColorStatus(cd) {
      var cls = '';
      switch(cd) {
        case 'MCSC000005': // 계획수립
          cls = 'text-primary';
          break;
        case 'MCSC000010': // 점검중
          cls = 'text-positive';
          break;
        case 'MCSC000015': // 점검완료
          cls = 'text-orange-10';
          break;
        case 'MCSC000020': // 지연
          cls = 'text-red';
          break;
      }
      return cls;
    },
    getColorStatus2(cd) {
      var cls = '';
      switch(cd) {
        case 'ASC0000001': // 계획수립
          cls = 'text-primary';
          break;
        case 'ASC0000002': // 점검중
          cls = 'text-positive';
          break;
        case 'ASC9999999': // 점검완료
          cls = 'text-orange-10';
          break;
      }
      return cls;
    },
    getList() {
      // 전체조회
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    /* eslint-disable no-unused-vars */ 
    linkClick(evt, row) {
      this.popupOptions.param = {
        deteriorCheckId: row ? row.deteriorCheckId : '',
      };
      this.popupOptions.title = row.deteriorName; 
      this.popupOptions.target = () =>
        import(`${"./equipmentDeteriorDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.isFull = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    getDailyDetail() {
      if (this.$route.query.equipmentCd) {
        this.$http.url = this.findResultUrl;
        this.$http.type = 'GET';
        this.$http.param = {
          equipmentCd: this.$route.query.equipmentCd,
          checkDate: this.$comm.getToday(),
        };
        this.$http.request((_result) => {
          if (_result.data) {
            this.popupOptions.param = {
              deteriorCheckId: _result.data.deteriorCheckId,
              equipmentCd: this.$route.query.equipmentCd,
            };
            this.popupOptions.title = _result.data.equipmentName + '의 열화관리점검 상세'; 
            this.popupOptions.target = () =>
              import(`${"./equipmentQrDeteriorDetail.vue"}`);
            this.popupOptions.visible = true;
            this.popupOptions.isFull = true;
            this.popupOptions.closeCallback = this.closePopup;
          } else {
            window.getApp.$emit('ALERT', {
              title: '안내', // 안내
              message: '현재일 기준으로 작성된 열화관리점검이 없습니다.',
              type: 'warning', // success / info / warning / error
            });
          }
        },);
      } else {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '존재하지 않는 설비입니다.',
          type: 'warning', // success / info / warning / error
        });
      }
    },
    onItemClick() {
      this.linkClick(null);
    },
    closePopup(type) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (type === 'COMPLETE' || type === 'SAVE') {
        window.getApp.$emit('APP_REQUEST_SUCCESS');
      }
      this.getList();
    },
    setTagColor(data) {
      if (this.colorItems) {
        let color = this.$_.find(this.colorItems, { code: data }) || this.$_.find(this.colorItems, { stepperMstCd: data })
        return color ? color.attrVal1 || color.colorClass : '';
      } else {
        return ''
      }
    },
    setTagName(data) {
      if (this.colorItems) {
        let color = this.$_.find(this.colorItems, { code: data }) || this.$_.find(this.colorItems, { stepperMstCd: data })
        return color ? color.codeName || color.stepperMstNm : '';
      } else {
        return ''
      }
    },
  },
};
</script>
<style>
.blinking {
  -webkit-animation:blink 3s ease-in-out infinite alternate;
  -moz-animation:blink 3s ease-in-out infinite alternate;
  animation:blink 3s ease-in-out infinite alternate;
}
@-webkit-keyframes blink {
  0% { opacity:0 }
  100% { opacity:1 }
}
@-moz-keyframes blink {
  0% { opacity:0 }
  100% { opacity:1 }
}
@keyframes blink {
  0% { opacity:0 }
  100% { opacity:1 }
}
</style>